import { useState, useEffect } from "react"
import { useNavigate, useLocation } from "react-router"
import { toast } from "react-toastify"
import Server from "../../Shared/Server"
import Spinner from "../../Shared/Spinner"
import {InputField} from "../../Shared/InputField"
import SelectField from "../../Shared/SelectField"

const ConnectMeterForm = (props) => {
    const [errors, setErrors] = useState({})
    const [isLoading, setIsLoading] = useState(false)
    const [meterOptions, setMeterOptions] = useState([])

    const [formData, setFormData] = useState({
        meter_id: "",
        location_id: ""
    })
    const {meter_id, location_id} = formData

    const navigate = useNavigate()
    const location = useLocation()

    useEffect(() => {

        if (location.state){
            const {location_id} = location.state
            setFormData((prev) => ({
                ...prev,
                location_id: location_id
            }))
        }
        
        fetchData()
    }, [location])

    const fetchData = async () => {
        setIsLoading(true)
        try {
            const meter_response = await Server.get('/meters/un-connected/')
            const meters = [{public_id: '', id: "", name: '-- Please choose meter --'}]
            meter_response.data.map(meter => (
                meters.push({
                    id: meter.id,
                    public_id: meter.public_id,
                    name: `ID: ${meter.serial_number}, Lock: ${meter.lock_number}, Remark: ${meter.remark}`
                })
            ))
            setMeterOptions(meters)
            setIsLoading(false) 
        } catch (error) {
            setIsLoading(false)

            setMeterOptions([])
        }
    }

    const onChange = (e) => {
        setFormData((prevState) => ({
            ...prevState,
            [e.target.name]: e.target.value
        }))
    }

    const onSubmit = (e) => {
        e.preventDefault()

        const payload = {location_id, meter_id}
        connectMeter(payload);
    }
    
    // add line
    const connectMeter = async (payload) => {
        setErrors({})
        setIsLoading(true)
        try {
            const response = await Server.post(`/locations/connect-meter/?location_id=${payload.location_id}&meter_id=${payload.meter_id}`)
            if (response.status === 200){
                toast.success(response.data?.detail)
                navigate('/locations')
                setIsLoading(false)
            }else{
                toast.error(response.data?.detail)
            }
        } catch (error) {
            setIsLoading(false)
            if(error.response.status === 401){
                navigate('/login')
            }else if (error.response.status === 422) {
                setErrors({})
                error.response?.data?.detail.map((err) => (
                    setErrors((prevState) => ({
                        ...prevState,
                        [err.loc[1]]: err.msg
                    }))
                ))
            }else if (error.response.status === 403){
                toast.error(error.response.data.detail);
                navigate('/');
            }else {
                toast.error(error.response?.data?.detail)
            }
        }
    }

    if(isLoading){
        return <Spinner/>
    }

  return (
    <>
        <div className="card">
            <div className="card-header p-2 bg-info text-white d-flex justify-content-center">
                <h3 className="card-title">Connect Meter Form</h3>
            </div>
            <div className="card-body">
                <form onSubmit={onSubmit}>
                    <div className="row">
                        <div className="col-md-12">
                            <SelectField
                                name="meter_id"
                                label="Meter"
                                value={parseInt(meter_id)}
                                options={meterOptions}
                                onChange={onChange}
                                error={errors.meter_id}
                            />
                        </div>
                    </div>
                    <br/>
                    <div className="row">
                        <div className="col-md-12">
                            <input type="submit" className="btn btn-outline-info" value="Connect Meter" style={{float: 'right'}}/>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <br/>
    </>
  )
}

export default ConnectMeterForm
